import { render, staticRenderFns } from "./CompSelect.vue?vue&type=template&id=151bf4fc&scoped=true&"
import script from "./CompSelect.vue?vue&type=script&lang=js&"
export * from "./CompSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151bf4fc",
  null
  
)

export default component.exports